@for (errorItem of errorList; track errorItem) {
  <billing-payment-error-item [errorItem]="errorItem"></billing-payment-error-item>
}
